/**
 * PUBLIC runtime configuration only. Never place HighLevel tokens, Stripe secret keys,
 * webhook secrets or Meta CAPI tokens here — this file ships in the browser bundle.
 */
export const siteConfig = {
  domainTarget: 'floridalocalmovers.instamoversfl.com',
  /** Booking backend base URL. null = preview mode (nothing is sent anywhere). */
  apiBaseUrl: null as string | null,
  /** Restricted browser key for Google Places. null = manual address entry + team review. */
  mapsBrowserKey: null as string | null,
  /** InstaMovers Florida's own Meta dataset only. Not Tampa Local Movers / GritVue. */
  metaPixelId: '555793400074206' as string | null,
  /** Real Shopify product/cart link for the $99 deposit. null = Shopify button hidden. */
  shopifyCheckoutUrl: null as string | null,
  /** Public legal pages (routes in App.tsx). Full URLs once published on the custom domain. */
  privacyUrl: 'https://floridalocalmovers.instamoversfl.com/privacy-policy' as string | null,
  smsTermsUrl: 'https://floridalocalmovers.instamoversfl.com/terms-and-conditions' as string | null,
  /** Flip only after end-to-end tests pass on the live backend. */
  depositCheckoutEnabled: false,
  prepayEnabled: false,
  onlineSigningEnabled: false,
};

/**
 * Customer-facing website title. Florida Local Movers is NOT a separate company or registered DBA:
 * the operator is InstaMovers Florida LLC (data/business.ts), named in the footer, consent and legal pages.
 */
export const brand = {
  name: 'IMF Florida Local Movers',
  mark: 'IMF',
  word: 'Florida Local Movers',
};

export const phones = {
  ai: { display: '(656) 268-0800', href: 'tel:+16562680800', e164: '+16562680800' },
  human: { display: '(813) 851-0590', href: 'tel:+18138510590', e164: '+18138510590' },
};

export function isLive(): boolean {
  return !!siteConfig.apiBaseUrl;
}
